import React, { useState } from 'react';
import { Redirect, useHistory, Link } from 'react-router-dom';
import {
  Box,
  Typography,
  Grid,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Page from '../../components/Layout/Page';
import RegisterForm from './RegisterForm';
import SuccessModal from './SuccessModal';
import AuthService from '../../services/authService';
import useStyles from './styles';

function RegisterView() {
  const classes = useStyles();
  const history = useHistory();
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  if (AuthService.isAuthenticated()) {
    return <Redirect to="/causas" />;
  }

  const handleSuccess = () => {
    setShowSuccessModal(true);
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
    history.push('/ingreso');
  };

  return (
    <Page className={classes.root} title="Crear cuenta">
      <Grid container className={classes.grid}>
        <Grid item lg={7} md={7} sm={12} xs={12}>
          <div className={classes.loginImage}>
            <img
              alt="logo BSS"
              src="/img/logo_bss_white.png"
              className={classes.logoImage}
            />
          </div>
        </Grid>
        <Grid item lg={5} md={5} sm={12} xs={12}>
          <Box className={classes.content} textAlign="center" bgcolor="background.paper" minHeight="100vh" pt={3}>
            <Link to="/ingreso" className={classes.backLink}>
              <ArrowBackIcon fontSize="small" />
              Volver
            </Link>
            <Typography variant="h5" component="h1" gutterBottom fontWeight="bold" color="textPrimary">
              Crear cuenta
            </Typography>
            <RegisterForm className={classes} onSuccess={handleSuccess} />
          </Box>
        </Grid>
      </Grid>
      <SuccessModal open={showSuccessModal} onClose={handleCloseModal} />
    </Page>
  );
}

export default RegisterView;
